import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Lock, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="comprar" className="bg-navy py-24 px-6 relative overflow-hidden" data-id="element-172">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-light via-navy to-navy opacity-50" data-id="element-173"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-6" data-id="element-176">
            Tu descanso no tiene precio
          </h2>
          <p className="text-xl text-cream/80 mb-12 leading-relaxed" data-id="element-177">
            Recuperar tu salud mental, tu sueño y tu energía no debería costar
            una fortuna. Accede hoy mismo al sistema completo por una fracción
            de lo que cuesta un consultor de sueño.
          </p>

          <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-gold/20 max-w-xl mx-auto" data-id="element-178">
            <div className="inline-block bg-red-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-179">
              Oferta por tiempo limitado
            </div>
            <div className="text-navy/40 font-semibold uppercase tracking-wider mb-1 text-sm" data-id="element-180">
              Precio regular
            </div>
            <div className="text-2xl md:text-3xl font-serif font-bold text-navy/40 line-through mb-2" data-id="element-181">
              $27.00 USD
            </div>
            <div className="text-navy/60 font-semibold uppercase tracking-wider mb-1 text-sm" data-id="element-182">
              Precio de hoy
            </div>
            <div className="text-5xl md:text-7xl font-serif font-bold text-navy mb-2" data-id="element-183">
              $6.39 <span className="text-2xl text-navy/50" data-id="element-184">USD</span>
            </div>
            <div className="inline-block bg-green-100 text-green-700 text-sm font-bold px-4 py-1.5 rounded-full mb-8" data-id="element-185">
              ¡Ahorras un 76%!
            </div>

            <Button href="https://capacitacionesenlinea.com/cart/48205341753444:1" className="w-full py-5 text-xl mb-6 shadow-gold/20" data-id="element-186">
              ¡QUIERO RECUPERAR MIS NOCHES AHORA!
            </Button>

            <div className="flex flex-col items-center gap-3 text-sm text-navy/60 font-medium" data-id="element-187">
              <div className="flex items-center gap-2" data-id="element-188">
                <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-189" />
                Acceso inmediato por descarga digital.
              </div>
              <div className="flex items-center gap-2" data-id="element-190">
                <Lock className="w-4 h-4 text-gold" data-id="element-191" />
                Pago seguro y cifrado.
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}